export default __webpack_public_path__ + "static/points-26f6ee4aa830fbe9b4c8c5d95e1a9a12.svg";